// removed by extract-text-webpack-plugin
module.exports = {"notFoundWrapper":"qz7tNI1-j08G0HbSHUlaz","content":"_1TNTHwgNV72kDlBNay2wym","formSearch":"tXseg5bM32DFtLcVrHiE2","icon":"_2lO-bIRpyMRne0WazGyZqn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/InviteStaff/InviteStaffPage.scss
// module id = 1861
// module chunks = 0